// extracted by mini-css-extract-plugin
export default {"optionalNotice":"DetailsStep_optionalNotice__gKNK3","optionalIcon":"DetailsStep_optionalIcon__7Z5fc","waitlistOptions":"DetailsStep_waitlistOptions__Oqnrf"};